import { render, staticRenderFns } from "./returnTure.vue?vue&type=template&id=41d86560&scoped=true"
import script from "./returnTure.vue?vue&type=script&lang=js"
export * from "./returnTure.vue?vue&type=script&lang=js"
import style0 from "./returnTure.vue?vue&type=style&index=0&id=41d86560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d86560",
  null
  
)

export default component.exports